import { toast, ToastContainer, ToastOptions } from 'react-toastify';
import styled from 'styled-components';

import { isDLError } from '../errors';
import { getLangFromWindow } from '../reducers/preference.reducer';

export const StyledToastContainer = styled(ToastContainer)`
  // https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity
  &&&.Toastify__toast-container {
  }
  .Toastify__toast {
    min-height: 0;
    border-radius: 1px;
  }
  .Toastify__toast-body {
    font-size: 0.8rem;
  }
  .Toastify__progress-bar {
    height: 2px;
  }
`;

const COMMON_TOAST_OPTIONS: ToastOptions<Record<string, never>> = {
  position: 'top-center',
  autoClose: 15_000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'light',
};

const NETWORK_ERROR_TOAST_OPTIONS: ToastOptions<Record<string, never>> = {
  position: 'bottom-right',
  autoClose: 1500,
  hideProgressBar: true,
  theme: 'light',
};

export const COMMON_TOAST_SUCCESS_OPTIONS: ToastOptions<Record<string, never>> =
  {
    ...COMMON_TOAST_OPTIONS,
    autoClose: 3000,
  };

const _toastError = (message: string) =>
  toast.error(message, {
    ...COMMON_TOAST_OPTIONS,
    toastId: message, // deduplicate
  });

export const toastError = (error: string | Error): void => {
  const message =
    typeof error === 'string'
      ? error
      : isDLError(error)
        ? error.getMessage(getLangFromWindow())
        : error.message;
  const isNetworkError =
    typeof error !== 'string' &&
    isDLError(error) &&
    error.name === 'NetworkError';
  if (isNetworkError) {
    toast.warn(message, {
      ...NETWORK_ERROR_TOAST_OPTIONS,
      toastId: message, //deduplicate
    });
  } else {
    _toastError(message);
  }
};
